<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  mounted() {
    if(location.pathname.indexOf("intent") >= 0 || location.pathname.indexOf("store") >= 0 || location.pathname.indexOf("myIntent") >= 0 || location.pathname.indexOf("verifyList") >= 0 || location.pathname.indexOf("memberCard") >= 0){
      return;
    }
    if (this._isMobile()) {
      if(location.pathname.indexOf("mobile") == -1){
        location.replace('/abc/mobile');
      }
    } else {
      if(location.pathname.indexOf("mobile") != -1){
        location.replace('/abc/content');
      }
    }
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
}
</script>

<style lang="postcss" scoped>

</style>




// WEBPACK FOOTER //
// src/App.vue